import { MsClose as v } from "@sunrise/icons";
import { pageUtils as s, clickAnywhereHandler as c } from "@sunrise/shared";
import { defineComponent as b, ref as u, onMounted as p, watchPostEffect as g, watch as E } from "vue";
import { createUUID as y } from "./index228.js";
import S from "./index40.js";
import h from "./index170.js";
const n = -1, B = b({
  name: "CsTooltipModal",
  components: {
    MsClose: v,
    CsSecondaryButton: S,
    MsHeadline: h
  },
  model: {
    prop: "visible",
    event: "update:visible"
  },
  props: {
    id: {
      type: String,
      default: () => y("cs-tooltip-modal-")
    },
    visible: {
      type: Boolean,
      default: !1
    },
    labelledBy: String,
    describedBy: String,
    width: String,
    height: String
  },
  emits: ["update:visible"],
  setup(t, { emit: r }) {
    const e = u(null), i = u(null);
    let l = n;
    p(() => {
      t.visible && a(), g(() => t.visible ? f() : d());
    }), E(
      () => t.visible,
      (m) => m ? a() : o()
    );
    function f() {
      e.value && (i.value = document.activeElement, e.value.focus());
    }
    function d() {
      document.activeElement instanceof HTMLElement && document.activeElement.blur(), i.value && (i.value.focus(), i.value = null);
    }
    async function a() {
      s.disablePageScroll(), n === l && setTimeout(() => {
        e.value && (l = c.subscribe(e.value, o));
      });
    }
    function o() {
      t.visible && r("update:visible", !1), s.enablePageScroll(), c.unsubscribe(l), l = n;
    }
    return {
      dialogRef: e,
      closeModal: o
    };
  }
});
export {
  B as default
};
